<template>
  <v-container>
    <div class="popCon_txt row_mb-40">
      <br /><span class="fc_p02"
        >{{ accountform.name }}({{ accountform.email }})</span
      >
      님의 개인 블록체인 주소를 생성합니다.<br />
      블록체인 주소 생성을 완료하시면 회원가입이 완료됩니다.
    </div>
    <v-form ref="bcAddrInfos" v-model="valid" lazy-validation>
      <div class="popCon_input_W100_cov">
        <v-text-field
          class="inputH48_01 conBstar"
          label="블록체인 비밀번호"
          placeholder="영어, 숫자 포함. 6~12자리로 입력"
          outlined
          dense
          v-model="bcAddrInfo.bc_password"
          :type="'password'"
          :rules="rules.passwordRules"
        >
        </v-text-field>
        <v-text-field
          class="inputH48_01 conBstar"
          label="블록체인 비밀번호 확인"
          placeholder="영어, 숫자 포함. 6~12자리로 입력"
          outlined
          dense
          v-model="bcAddrInfo.bc_password_re"
          :type="'password'"
          :rules="[
            bcAddrInfo.bc_password === bcAddrInfo.bc_password_re ||
              '비밀번호가 일치하지않습니다'
          ]"
        >
        </v-text-field>
        <ul class="pattern_ul_terms12 row_mb-40">
          <li>- 가입 회원에게 부여되는 개인 블록체인 주소입니다.</li>
          <li class="fc_C05">
            - 블록체인 비밀번호 분실시 글로싸인엔터프라이즈에서 비밀번호 찾기
            또는 초기화 할 수 없습니다. 비밀번호를 정확히 기억하시기 바랍니다.
          </li>
        </ul>
      </div>
    </v-form>
    <v-card-actions class="justify-center signup_btnCon">
      <v-btn
        outlined
        class="btn19_00 btnC_01 btn_bottom_W314"
        @click="submitBcConfirm()"
        >회원 등록</v-btn
      >
      <!--다음으로 이동-->
    </v-card-actions>
    <s-confirm ref="confirm"></s-confirm>
    <s-loading ref="loading"></s-loading>
  </v-container>
</template>
<script>
import sha256 from "sha256";
import { createTempUser } from "@/api/join";

export default {
  name: "acceptTerm",
  props: {
    parentData: {}
  },
  compenonts: {
    sha256
  },
  data() {
    return {
      valid: true,
      rules: {
        passwordRules: [
          v => !!v || "블록체인 비밀번호를 입력해 주세요",
          v =>
            /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{6,12}$/.test(v) ||
            "영어, 숫자 포함하여 6~12자리로 입력해 주십시요"
        ]
      },
      accountform: {
        auth_key: "",
        email: "",
        radio_trem_paivacy_op1: false,
        radio_trem_paivacy_op2: false,
        userid: "",
        password: "",
        password_re: "",
        name: "",
        addr_main: "",
        addr_sub: "",
        phone: ""
      },
      bcAddrInfo: {
        bc_addr: "",
        bc_password: "",
        bc_password_re: ""
      },
      send_accountform: {
        userid: "",
        password: "",
        password_re: "",
        name: "",
        email: "",
        addr_main: "",
        addr_sub: "",
        phone: ""
      },
      sendData: {
        tempUserInfo: null
      },
      term_info: {
        TERM_CTR_MAIL: false,
        TERM_MAIL: false
      }
    };
  },
  created() {
    this.accountform = this.parentData;
    if (this.$store.state.user.username !== "") {
      this.$refs.confirm
        .open(
          "confirm",
          "회원가입",
          "로그인 사용자입니다. 로그아웃 후 이용하세요"
        )
        .then(() => {
          this.$router.push("/");
        });
    } else {
      this.mounted();
    }
  },
  methods: {
    mounted() {
      if (this.accountform.auth_key === undefined) {
        // console.log('not found auth_key')
        this.invalid_authkey();
      } else {
        this.term_info.TERM_CTR_MAIL = this.accountform.radio_trem_paivacy_op1;
        this.term_info.TERM_MAIL = this.accountform.radio_trem_paivacy_op2;
      }
    },
    invalid_authkey() {
      this.$refs.confirm
        .open("confirm", "회원가입", "인증정보가 없습니다. 다시 시도해주세요.")
        .then(() => {
          this.$router.push({ name: "join" });
        });
    },
    submitBcConfirm() {
      this.$refs.confirm
        .open(
          "confirm",
          "회원가입",
          "블록체인 생성후에는 비밀번호 찾기 또는  초기화를 할 수 없습니다. 비밀번호를 정확히 기억하시기 바랍니다."
        )
        .then(() => {
          this.submitBcAddr("bcAddrInfos");
        });
    },
    submitBcAddr(formName) {
      var validate = this.$refs.bcAddrInfos.validate();
      if (validate) {
        // console.log('submit!!')

        var hp = sha256(this.accountform.password);

        this.send_accountform.userid = this.accountform.userid;
        this.send_accountform.password = hp;
        this.send_accountform.password_re = hp;
        this.send_accountform.name = this.accountform.name;
        this.send_accountform.email = this.accountform.email;
        this.send_accountform.addr_main = this.accountform.addr_main;
        this.send_accountform.addr_sub = this.accountform.addr_sub;
        this.send_accountform.phone = this.accountform.phone;

        this.createTempUser();
      } else {
        // console.log('error submit!!')
        return false;
      }
    },
    createTempUser() {
      // 임시유저 생성
      this.$refs.loading.start("입력 정보 확인 중");
      this.$nextTick(() => {
        createTempUser(
          JSON.stringify({
            user: this.send_accountform,
            bc_password: this.bcAddrInfo.bc_password,
            auth_key: this.accountform.auth_key,
            term_info: this.term_info
          })
        ).then(Response => {
          if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
            this.$refs.loading.end();
            this.sendData.tempUserInfo = Response.rdata.user;
            this.$emit("chainAddrEvent", this.sendData);
          } else {
            this.$refs.loading.end();
            var msg = "";
            if (Response.rdata === undefined) {
              msg = Response.message;
            } else {
              msg = Response.rdata.message;
            }
            this.$refs.confirm.open("alert", "회원가입 실패", msg);
          }
        });
      });
    }
  }
};
</script>
<style scoped></style>
